import { faCircleInfo, faCirclePlus, faEye } from '@fortawesome/pro-light-svg-icons'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { operationTypesInversed } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney/cashRegisterMoneyLog'
import { sellTicketStatusInversed, sellTicketTypeInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import { Fragment, useCallback } from 'react'
import ModalPaymentMethodTPV from '../../../../../app/erp/screens/TPV/TPVDashboard/Components/ProductTicketTPVDSB/ModalPaymentMethodTPV'
import ModalPaymentMethodInfoTPV from '../../../../../app/erp/screens/TPV/TPVDashboard/Components/ProductTicketTPVDSB/ModalPaymentMethodTPV/ModalPaymentMethodInfoTPV'
import ModalProcessRegularizeSellTicket from '../../../../../app/erp/screens/TPV/TPVDashboard/Components/ProductTicketTPVDSB/Steps/SellTicketFinishedStep/ModalProcessRegularizeSellTicket'
import { parsedTicketTableData } from '../../../../../app/erp/screens/TPV/TPVDashboard/functions'
import { DisplayPriceGettingParams } from '../../../../../baseComponents/Displays/DisplayPrice'
import { ButtonConfigColumnsWithModal } from '../../../../../baseComponents/ModalsLayouts/ModalConfigColumnsTabs'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinIcon, { TwinIconToolTip } from '../../../../../baseComponents/TwinIcon'
import { ITHookFunctionTy, ITLayoutTableModalOpenSetTy } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableURLsTable } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import TableWithCustomVirtualListing from '../../../../../baseComponents/TwinTable/TableWithCustomVirtualListing'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { displayDate } from '../../../../../utils/globals/date'
import useOrderCalculateTotals from '../../../../../utils/hooks/orders/useOrderCalculateTotals'
import useConfigColumns from '../../../../../utils/hooks/useConfigColumns'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import { useMeasureShortsDictionary } from '../../../../../utils/hooks/useMeasureDictionary'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getISOCurrencyMain, getPaymentTypes, getUserPermissions } from '../../../../../utils/reducers/getters'
import { InputTableSellTicketFooterFullProps, InputTableSellTicketLayoutProps, SetTPVCompleteDataTy, TPVOrderData } from '../types'

interface InputTableSellTicketProps extends InputTableSellTicketLayoutProps {
    hookFunction: ITHookFunctionTy
    TableChildren: React.FC<InputTableSellTicketFooterFullProps>
}

const InputTableSellTicket: React.FC<InputTableSellTicketProps> = ({ columns, completeData, setCompleteData, hookFunction, title, name, TableChildren, TableButtons, ...rest}) => {
    const { t } = useTwinTranslation()
    const currency = getISOCurrencyMain()
    const { setSelectedColumnsAndFilters, memorizedColumns, selectedColumnsAndFilters } = useConfigColumns({ columns, name })
    const { parsedColumns, rowRenderer, containerRenderer, onChangeSearchBar, filters, ...resty } = hookFunction({ completeData: completeData as any, columns: memorizedColumns, CurrencyId: currency, setCompleteData: setCompleteData as any, ...rest })
    const parsedTableData = completeData?.filteredTableData || completeData?.tableData
    const parseFilteredData = useCallback((rowIndex: number) => {
        return completeData?.tableData?.[completeData.dictPosTableData?.[parsedTableData?.[rowIndex].id]]
    }, [completeData?.dictPosTableData, completeData?.tableData, parsedTableData])
    const ticketNumber = completeData?.header?.full_assigned_number || ''
    const dateTicket = completeData?.header?.createdAt ? displayDate(new Date(completeData?.header?.createdAt)) : ''
    const dateReservedTicket = completeData?.header?.reservedDate && completeData?.header?.type !== sellTicketTypeInversed['partialCharged'] ? displayDate(new Date(completeData?.header?.reservedDate)) : ''
    const ticketTextNumber = completeData?.header?.SellTicketId || completeData?.header?.readOnly ? t('numDot', 'Núm.') : t('draft', 'Borrador')
    return (
        <div className='flex flex-auto flex-col gap-8 overflow-hidden input_table_whitebox table_sell_ticket'>
            <div className='flex items-center product_ticket_title '>
                <h3 className=''>{title}</h3>
                <div className='flex flex-row gap-x-10 items-center light14 text-gray-51 ml-10'>{ticketTextNumber + ' ' + ticketNumber}</div>
                <RefundTicketLink {...{completeData, setCompleteData, getCompleteData: rest.getCompleteData}} />
                {dateReservedTicket ?
                    <div className='flex ml-20 light14'>
                        <TwinTrans transKey={'aproximateDeliveryDate'}>Fecha de entrega aproximada</TwinTrans>:
                        <div className='ml-10'>{dateReservedTicket}</div> 
                    </div>
                    : null}
                <TicketLink completeData={completeData} getCompleteData={rest.getCompleteData}/>
                <div className='ml-auto flex items-center'>
                    <div className='mr-10'>{dateTicket}</div>
                    <OpenInfoModalButton completeData={completeData} inputTableURLs={rest.inputTableURLs} getCompleteData={rest.getCompleteData} />
                    <ButtonConfigColumnsWithModal name={name} columns={columns} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} selectedColumnsAndFilters={selectedColumnsAndFilters} haveFiltersColumn={false} setTableConfiguration={() => { }} getTableDataFromStart={() => { }} hideLoadFiltersButton={true}/>
                </div>
            </div>
            <div className='flex flex-col flex-auto h-1 gap-15 product_ticket_content'>
                <div className='flex flex-auto flex-col h-1 gap-5 input_table_table'>
                    <TableWithCustomVirtualListing columns={parsedColumns} data={parsedTableData || []} rowRenderer={rowRenderer} containerRenderer={containerRenderer} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} name={name} updateEmployeeParameter={true} headerChanges={{ changeOrder: () => { }, changeSingleField: resty.eventFunctions.changeSingleField }} filters={filters} getDataFnc={completeData?.filteredTableData ? parseFilteredData : undefined as any} />
                    {!completeData?.header?.hidePrices ? <OrderSellTicketTotals completeData={completeData as any} currency={currency} titleTotal={rest.titleTotal} readOnly={completeData?.header?.readOnly} setOpenModal={resty.setOpenModal} /> : null}
                </div>
            </div>
            <TableButtons {...{completeData: completeData as any, setCompleteData, ...rest}} />
            <TableChildren CurrencyId={currency} orderStatusDict={{} as any} {...{ setCompleteData, completeData, columns: memorizedColumns, parsedTableData, onChangeSearchBar, ...resty, ...rest, isReadOnly: completeData?.header?.readOnly }} />
            {rest.children}
        </div>
    )
}

interface OrderSellTicketTotalsProps {
    completeData: TPVOrderData
    currency: string
    titleTotal?: string
    readOnly: boolean
    setOpenModal: ITLayoutTableModalOpenSetTy
}

const OrderSellTicketTotals: React.FC<OrderSellTicketTotalsProps> = ({ completeData, currency, titleTotal, readOnly, setOpenModal }) => {
    const {t} = useTwinTranslation()
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData })
    const showIcon = (completeData?.header?.id && !readOnly) || (readOnly && totalsOrderTableData.totals.discounts_after && !completeData?.header?.SellTicketId)
    const canCreateDiscounts = permissionCheck(getUserPermissions('sellOther.createDiscounts'), 'read')
    const showDiscount = !readOnly || totalsOrderTableData.totals.discounts_after
    const diffTotalRest = totalsOrderTableData.totals.total !== totalsOrderTableData.totals.total_clean_with_vat
    const isPartialCharged = parseInt(String(completeData?.header?.status)) === sellTicketStatusInversed['partialCharged']
    const isCanceled = parseInt(String(completeData?.header?.status)) === sellTicketStatusInversed['canceled']
    const { measureItems }: any = useMeasureShortsDictionary()
    const renderThis: JSX.Element[] = []
    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measureItems[unit]
        renderThis.push(<TotalsTablePriceTPV title={label} value={totalsOrderTableData.totals.units[unit]} CurrencyId={''} className='capitalize light12 ' classNamePrice='regular12' key={unit} />)
    }
    const myTitle = titleTotal && !isCanceled ? titleTotal : t('total', 'Total')
    return (
        <div className='flex ml-auto border-t border-gray-D6 w-full flex-wrap pt-10 items-end gap-y-5'>
            <div className='flex items-center flex-wrap footer_totals_info flex-auto '>
                {renderThis}
                {showDiscount || !parseFloat(completeData?.header?.total_refund_with_vat || '0') ? <TotalsTablePriceTPV title={t('subtotal', 'Subtotal')} value={totalsOrderTableData.totals.subTotalAfterPrev} CurrencyId={currency} className='light12' classNamePrice='regular12' /> : null}
                {showDiscount ? <TotalsTablePriceTPVWithModal title={t('discountShort', 'Dto.')} value={totalsOrderTableData.totals.discounts_after} CurrencyId={currency} showIcon={showIcon} readOnly={readOnly || !canCreateDiscounts} id='discountFooterTPV' translations={{ editText: t('addEditDiscount', 'Añadir o editar descuento'), showText: t('seeDiscountsInfo', 'Ver descuentos') }} onClickEdit={() => setOpenModal({ type: 'addDiscount', allRowData: { ...completeData?.header, readOnly: readOnly || !canCreateDiscounts } })} className='light12' classNamePrice='regular12' /> : null}
                {parseFloat(completeData?.header?.total_refund_with_vat) ? <TotalsTablePriceTPV title={t('refunded', 'Devuelto')} value={completeData?.header?.total_refund_with_vat} CurrencyId={currency} className='light12' classNamePrice='regular12' /> : null}
                {diffTotalRest ? <TotalsTablePriceTPV title={t('totalRest', 'Restante')} value={completeData?.header?.total_clean_with_vat} CurrencyId={currency} className='light12' classNamePrice='regular12'  /> : null}
                {isPartialCharged && parseFloat(completeData?.header?.total_payed) ? <TotalsTablePriceTPV title={t('payedM', 'Pagado')} value={completeData?.header?.total_payed} CurrencyId={currency} className='light12' classNamePrice='regular12'  /> : null}
                {isCanceled
                    ? <TotalsTablePriceCanceledTPV {...{ completeData, currency }} />
                : null}
            </div>
            <div className='flex gap-x-10 ml-auto'>
                {isPartialCharged ? <TotalsTablePriceTPV title={t('ticketRest', 'Restante')} value={completeData?.header?.total_to_pay} CurrencyId={currency} className='light20 ml-auto total_separator' classNamePrice='regular26 leading-26 ml-8' classNameLabel='mt-1 leading-20' /> : null}
                <TotalsTablePriceTPV title={myTitle} value={totalsOrderTableData.totals.total} CurrencyId={currency} className='light20 ml-auto' classNamePrice='regular26 leading-26 ml-8' classNameLabel='mt-1 leading-20' />
            </div>
        </div>
    )
}

interface TotalsTablePriceCanceledTPVProps {
    currency: string
    completeData: TPVOrderData
}

const TotalsTablePriceCanceledTPV: React.FC<TotalsTablePriceCanceledTPVProps> = ({ currency, completeData }) => {
    const { t } = useTwinTranslation()
    return (
        <Fragment>
            <TotalsTablePriceTPV title={t('payedM', 'Pagado')} value={completeData?.header?.total_payed} CurrencyId={currency} className='light12' classNamePrice='regular12' />
            <TotalsTablePriceTPV title={t('Refunded', 'Devuelto')} value={completeData?.header?.total_payed} CurrencyId={currency} className='light12' classNamePrice='regular12' />
        </Fragment>
    )
}


interface TotalsTablePriceTPVProps {
    title: string
    value: any
    CurrencyId: string
    className?: string
    classNamePrice?: string
    classNameLabel?: string
}

const TotalsTablePriceTPV: React.FC<TotalsTablePriceTPVProps> = ({ CurrencyId, value, title, className, classNamePrice, classNameLabel }) => {
    return (
        <div className={' flex items-center totals_table_price_tpv_item ' + (className || '')}>
            <span className={'totals_table_price_tpv_item_label ' + (classNameLabel || '')}>{title}</span>
            <span className={(classNamePrice || '')}><DisplayPriceGettingParams CurrencyId={CurrencyId} value={value} with_vat={false} /></span>
        </div>
    )
}

interface TotalsTablePriceTPVWithModallProps extends TotalsTablePriceTPVProps {
    showIcon: boolean
    readOnly: boolean
    translations?: {
        editText: string,
        showText: string
    }
    id: string
    onClickEdit?: () => void
}

const TotalsTablePriceTPVWithModal: React.FC<TotalsTablePriceTPVWithModallProps> = ({ showIcon, readOnly, translations, id, onClickEdit, ...rest }) => {
    return (
        <div className='flex items-center totals_table_price_tpv_item'>
            <TotalsTablePriceTPV {...{...rest} } />
            {showIcon ? <TwinIconToolTip className='text-green-21 ml-8' icon={readOnly ? faCircleInfo : faCirclePlus} message={readOnly ? translations?.showText || '' : translations?.editText || ''} id={id} onClick={onClickEdit} classNameIcon='w-16 h-16' /> : null}
        </div>
    )
}

interface OpenInfoModalButtonProps extends OpenInfoModalButtonLogicProps {
    inputTableURLs: InputTableURLsTable
    getCompleteData: (prop1?: any, prop2?: any) => Promise<void>
}

const OpenInfoModalButton: React.FC<OpenInfoModalButtonProps> = ({ completeData, inputTableURLs, getCompleteData }) => {
    const { t } = useTwinTranslation()
    const { openModal, handleOpenInfoModal, setOpenModal } = useOpenInfoModalButtonLogic({ completeData })
    if (!completeData?.header?.readOnly || !completeData?.header?.id) {
        return null
    }
    return (
        <Fragment>
            <div className='cursor-pointer' onClick={handleOpenInfoModal}><TwinIcon icon={faEye} className='mr-10' /></div>
            {openModal?.type === 'create' ? <ModalPaymentMethodTPV completeData={completeData} setOpenModal={setOpenModal} url={''} onSubmit={() => { }} isRefund={true} openModal={openModal} allRowData={openModal?.allRowData} isReservedRefund={true} translations={{ textButton: t('confirmRegularization', 'Confirmar regularización'), textTotal: t('totalTicket', 'Total Ticket')}} /> : null}
            {openModal?.type === 'edit' ? <ModalProcessRegularizeSellTicket setOpenModal={setOpenModal} allRowData={openModal?.allRowData} url={'/api/app/order/tpv/sellTicket/regularizeSellTicket'} completeData={completeData} onSubmit={() => { getCompleteData(completeData?.header?.id) }} /> : null}
            {openModal?.type === 'delete' ? <ModalPaymentMethodInfoTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} isRefund={completeData?.header?.SellTicketId ? true : false} handleCloseModal={() => setOpenModal(null)} inputTableURLs={inputTableURLs} /> : null}
        </Fragment>
    )
}

interface OpenInfoModalButtonLogicProps {
    completeData: TPVOrderData | null
}

const useOpenInfoModalButtonLogic = ({ completeData }: OpenInfoModalButtonLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const paymentTypes = getPaymentTypes()
    const handleOpenInfoModal = useCallback(() => {
        let myPaymentMethodInfo = []
        const myPaymentMethodInfoRefund = []
        const myCashRegisters = completeData?.header?.CashRegisterMoneys
        for (const element of myCashRegisters || []) {
            let total = 0
            let totalRefund = 0
            for (const log of element.CashRegisterMoneyLogs) {
                if (log.operationType === operationTypesInversed['ticket']) {
                    total = total + parseFloat(String(log.money))
                } else if (log.operationType === operationTypesInversed['ticketRefund']) {
                    totalRefund = totalRefund + parseFloat(String(log.money))
                }
            }
            if (total) {
                myPaymentMethodInfo.push({ ...paymentTypes?.all[element.PaymentTypeId], quantity: roundNumberAndDecimals(total, totalCalculateParams) })
            }
            if (totalRefund) {
                myPaymentMethodInfoRefund.push({ ...paymentTypes?.all[element.PaymentTypeId], quantity: roundNumberAndDecimals(totalRefund, totalCalculateParams), operationType: 'ticketRefund' })
            }
        }
        if (myPaymentMethodInfoRefund?.length) {
            myPaymentMethodInfo = [...myPaymentMethodInfo, ...myPaymentMethodInfoRefund]
        }
        const canRegularize = (completeData?.header?.status === sellTicketStatusInversed['accepted']) && (completeData?.header?.CashRegisterId === completeData?.cashRegister?.id)
        setOpenModal({ type: 'delete', allRowData: { CurrencyId: completeData?.header?.CurrencyId, myTotalPayments: { total: completeData?.header?.total_total }, paymentMethodInfo: myPaymentMethodInfo, headerData: completeData?.header, OrderId: completeData?.header?.id, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId, canRegularize } })
        
    }, [setOpenModal, completeData, paymentTypes?.all])
    return { openModal, handleOpenInfoModal, setOpenModal }
}

interface TicketLinkProps extends TicketLinkLogicProps {}

const TicketLink: React.FC<TicketLinkProps> = ({...rest}) => {
    const { handleOpenReservedTicket } = useTicketLinkLogic({ ...rest })
    if (!rest.completeData?.header?.ReservedSellTicketId) {
        return null
    }
    return (
        <div className='ml-20 cursor-pointer text-gray-51 light14 hover:text-green-43' onClick={handleOpenReservedTicket}>
            <TwinTrans transKey='reservedTicket'>Ticket de reserva</TwinTrans>: <span>{rest.completeData?.header?.ReservedSellTicket?.full_assigned_number}</span>
        </div>
    )
}

interface TicketLinkLogicProps {
    completeData: TPVOrderData | null
    getCompleteData: (prop1?: any, prop2?: any) => Promise<void>
}

const useTicketLinkLogic = ({ getCompleteData, completeData }: TicketLinkLogicProps) => {
    const handleOpenReservedTicket = useCallback(() => {
        if (completeData?.header?.ReservedSellTicketId) {
            getCompleteData(completeData?.header?.ReservedSellTicketId)
        }
    }, [getCompleteData, completeData])
    return { handleOpenReservedTicket }
}
interface RefundTicketLinkProps extends RefundTicketLinkLogicProps {
    completeData: TPVOrderData | null
}

const RefundTicketLink: React.FC<RefundTicketLinkProps> = ({ completeData, ...rest}) => {
    const { handleOpenRefundTicket, handleOpenTicket } = useRefundTicketLinkLogic({ ...rest })
    
    if (completeData?.header?.SellTicketId && completeData?.header?.SellTicket?.full_assigned_number) {
        return <SellLink handleOpenSell={handleOpenTicket} id={completeData?.header?.SellTicketId} full_assigned_number={completeData?.header?.SellTicket?.full_assigned_number} />
    }
    if (!completeData?.header?.SellTicketRefunds?.length) {
        return null
    }
    const renderThis: JSX.Element[] = []
    for (const element of completeData?.header?.SellTicketRefunds) {
        renderThis.push(<SellLink handleOpenSell={handleOpenRefundTicket} id={element.id} full_assigned_number={element.full_assigned_number} /> )
    }
    return (
        <Fragment>
            {renderThis}
        </Fragment>
    )
}

interface RefundTicketLinkLogicProps {
    setCompleteData: SetTPVCompleteDataTy
    getCompleteData: (prop1?: any, prop2?: any) => Promise<void>
}

const useRefundTicketLinkLogic = ({ setCompleteData, getCompleteData }: RefundTicketLinkLogicProps) => {
    const handleOpenRefundTicket = useCallback(async (id: number) => {
        const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicketRefund/getSellTicketRefundComplete', { id })
        if (result) {
            setCompleteData((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                copyOld.header = result.header
                copyOld.tableData = result.tableData
                copyOld.lastProductIndex = null
                parsedTicketTableData(copyOld)
                return copyOld
            })
        }
    }, [setCompleteData])

    const handleOpenTicket = useCallback(async (id: number) => {
        await getCompleteData(id)
    }, [getCompleteData])
    return { handleOpenRefundTicket, handleOpenTicket }
}

interface SellLinkProps {
    id: number
    full_assigned_number: string
    handleOpenSell: (id: number) => Promise<void>
}

const SellLink: React.FC<SellLinkProps> = ({ handleOpenSell, id, full_assigned_number }) => {
    return (<div className='ml-5 cursor-pointer text-gray-51 light14 hover:text-green-43' onClick={() => handleOpenSell(id)}>
        <span> / {full_assigned_number}</span>
    </div>)
}



export default InputTableSellTicket